var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClosePopup = function SvgClosePopup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.774 4.774a1.095 1.095 0 0 1 1.549 0l12.903 12.903a1.095 1.095 0 0 1-1.549 1.549L4.774 6.323a1.095 1.095 0 0 1 0-1.549Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.226 4.774c.427.428.427 1.121 0 1.549L6.323 19.226a1.095 1.095 0 0 1-1.549-1.549L17.677 4.774a1.095 1.095 0 0 1 1.549 0Z"
  })));
};
export default SvgClosePopup;